import type { SelfServeState } from "./rootReducer";

export const getSupportChatState = (appState: SelfServeState) =>
  appState.selfServe.supportChat;

export const getHasActiveChatSession = (appState: SelfServeState) =>
  getSupportChatState(appState).activeChatSession;

export const getIsMinimized = (appState: SelfServeState) =>
  getSupportChatState(appState).isMinimized;

export const getSupportProductInfo = (appState: SelfServeState) =>
  getSupportChatState(appState).supportProductInfo;
